export const WELLO_IMAGE_PREFIX_URL = 'https://cdn.welfarehello.com';

//* 이미지 CDN이 죽으면 같은 CDN의 폴백도 같이 죽는다 — 앱 번들에서 낸다
export const IMAGE_PLACEHOLDER =
  '/images/local-market/placeholder-thumbnail.png';

//* 상세·캠페인 본문 폭(`max-w-[750px]`)에 맞춘 next/image sizes.
//* 안 주면 브라우저가 뷰포트를 모른 채 항상 최대 후보를 받는다(1-2.png 실측 131KB → 105KB).
export const CONTENT_IMAGE_SIZES = '(max-width: 750px) 100vw, 750px';
